module.exports = __webpack_public_path__ + "img/brush-studio_jp.602ab5a.jpg";